import { lazy } from 'react';

// project import
import Loadable from '../components/Loadable';
import MinimalLayout from '../layout/MinimalLayout';

// render - login
const Login = Loadable(lazy(() => import('../pages/authentication/Login')));
const Register = Loadable(lazy(() => import('../pages/authentication/Registration')));
const HomeScreen = Loadable(lazy(() => import('../pages/authentication/HomeScreen')));
const ForgotPossword = Loadable(lazy(() => import('../pages/authentication/ForgotPossword')));
const TrialExpiration = Loadable(lazy(() => import('../pages/Subscription/TrialExpiration')));
const SuccessPage = Loadable(lazy(() => import('../components/Payment/sub/SuccessPage')));
const FailurePage = Loadable(lazy(() => import('../components/Payment/sub/FailurePage')));
const PlanAndPricing = Loadable(lazy(() => import('../pages/Subscription/Subscription')));
const PrivacyPolicy = Loadable(lazy(() => import('../pages/authentication/PrivacyPolicy')));
const TermsConditions = Loadable(lazy(() => import('../pages/authentication/TermsConditions')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: 'login',
      element: <Login />
    },
    {
      path: 'register',
      element: <Register />
    },
    {
      path: 'homeScreen',
      element: <HomeScreen />
    },
    {
      path: 'forgotpassword',
      element: <ForgotPossword />
    },
    {
      path: 'renewSubscription',
      element: <TrialExpiration />
    },
    {
      path: 'success',
      element: <SuccessPage />
    },
    {
      path: 'failure',
      element: <FailurePage />
    },
    {
      path: 'pricing',
      element: < PlanAndPricing />
    },
    {
      path: 'privacypolicy',
      element: < PrivacyPolicy />
    },
    {
      path: 'termsconditions',
      element: < TermsConditions />
    },

  ]
};

export default LoginRoutes;
